export const VariantSelector = ({ product, selectedId, onSelect }) => (
  <div role="radiogroup" aria-label={`${product.name} package`} className="grid grid-cols-3 border border-black">
    {product.variants.map((v, i) => {
      const active = v.id === selectedId;
      return (
        <button
          key={v.id}
          type="button"
          role="radio"
          aria-checked={active}
          data-testid={`variant-option-${product.slug}-${v.id}`}
          onClick={() => onSelect(v.id)}
          className={`h-10 px-2 text-[12px] font-medium uppercase tracking-[0.12em] transition-colors duration-300 ${
            i > 0 ? "border-l border-black" : ""
          } ${active ? "bg-black text-white" : "bg-transparent text-black hover:bg-black/5"}`}
        >
          {v.name}
        </button>
      );
    })}
  </div>
);
